import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://ayyappapaniker.in";
const SITE_NAME = "Ayyappa Paniker Foundation";
const DEFAULT_IMAGE = `${SITE_URL}/icons/icon.svg`;
const malayalamRoutes = new Set([
  "/Kavi",
  "/vivarthakan",
  "/gadhyakaran",
  "/niroopakan",
  "/editer-samaaharakarthavu",
  "/adhyapakan-gaveshakan",
  "/english-gadhyakaran",
  "/aniyara-shilpi",
  "/ayyappapanikare-kurichulla-grandhangal",
]);

const pageMetadata = {
  "/": {
    title: "Ayyappa Paniker Foundation | Malayalam Poet and Literary Works",
    description: "Explore the life, poetry, books, translations, and literary legacy of Malayalam poet Ayyappa Paniker.",
  },
  "/about-us": {
    title: "About the Ayyappa Paniker Foundation",
    description: "Learn about the Ayyappa Paniker Foundation, its office bearers, executive members, and mission.",
  },
  "/life": {
    title: "Ayyappa Paniker Biography, Life and Academic Career",
    description: "Discover Ayyappa Paniker's life, academic career, memberships, awards, honours, and contributions to literature.",
  },
  "/poetrys": {
    title: "Ayyappa Paniker Poetry and Malayalam Poems",
    description: "Read about the poetry and Malayalam literary work of Ayyappa Paniker, a major modern Indian poet.",
  },
  "/translation": {
    title: "Ayyappa Paniker Translations",
    description: "Explore translations associated with Ayyappa Paniker and his contribution to Indian and world literature.",
  },
  "/edited-works": {
    title: "Ayyappa Paniker Edited Works",
    description: "Browse edited works and literary publications connected with Ayyappa Paniker.",
  },
  "/critical-works": {
    title: "Critical Works on Ayyappa Paniker",
    description: "Explore critical writing and scholarly works about Ayyappa Paniker and Malayalam literature.",
  },
  "/programmes": {
    title: "Ayyappa Paniker Foundation Programmes",
    description: "View programmes, events, and cultural activities from the Ayyappa Paniker Foundation.",
  },
  "/photo": {
    title: "Ayyappa Paniker Photos and Archives",
    description: "Browse photographs and visual archival material from the life and work of Ayyappa Paniker.",
  },
  "/video": {
    title: "Ayyappa Paniker Foundation Videos",
    description: "Watch videos, talks, and cultural content from the Ayyappa Paniker Foundation.",
  },
  "/photo-portraits-and-with-luminaries": {
    title: "Ayyappa Paniker Portraits and Literary Luminaries",
    description: "See portraits of Ayyappa Paniker and photographs with notable literary and cultural figures.",
  },
  "/photo-books": {
    title: "Books by and About Ayyappa Paniker",
    description: "Browse photographs and covers from books by and about Malayalam poet Ayyappa Paniker.",
  },
  "/Kavi": {
    title: "അയ്യപ്പപ്പണിക്കർ: കവി | Ayyappa Paniker as Poet",
    description: "അയ്യപ്പപ്പണിക്കരുടെ കവിതകളും കാവ്യജീവിതവും പരിചയപ്പെടുക. Explore Ayyappa Paniker's work as a Malayalam poet.",
  },
  "/vivarthakan": {
    title: "അയ്യപ്പപ്പണിക്കർ: വിവർത്തകൻ | Ayyappa Paniker as Translator",
    description: "അയ്യപ്പപ്പണിക്കരുടെ വിവർത്തന സാഹിത്യത്തെക്കുറിച്ചുള്ള വിവരങ്ങൾ.",
  },
  "/gadhyakaran": {
    title: "അയ്യപ്പപ്പണിക്കർ: ഗദ്യകാരൻ | Ayyappa Paniker as Prose Writer",
    description: "അയ്യപ്പപ്പണിക്കരുടെ ഗദ്യസാഹിത്യവും രചനകളും പരിചയപ്പെടുക.",
  },
  "/niroopakan": {
    title: "അയ്യപ്പപ്പണിക്കർ: നിരൂപകൻ | Ayyappa Paniker as Critic",
    description: "അയ്യപ്പപ്പണിക്കരുടെ സാഹിത്യ നിരൂപണ സംഭാവനകളെക്കുറിച്ച് അറിയുക.",
  },
  "/editer-samaaharakarthavu": {
    title: "അയ്യപ്പപ്പണിക്കർ: എഡിറ്റർ സമാഹാരകർത്താവ്",
    description: "അയ്യപ്പപ്പണിക്കരുടെ എഡിറ്റർ, സമാഹാരകർത്താവ് എന്ന നിലയിലെ സാഹിത്യ സംഭാവനകൾ.",
  },
  "/adhyapakan-gaveshakan": {
    title: "അയ്യപ്പപ്പണിക്കർ: അധ്യാപകനും ഗവേഷകനും",
    description: "അയ്യപ്പപ്പണിക്കരുടെ അധ്യാപകനും ഗവേഷകനുമായുള്ള പ്രവർത്തനങ്ങളെക്കുറിച്ച് അറിയുക.",
  },
  "/english-gadhyakaran": {
    title: "അയ്യപ്പപ്പണിക്കർ: ഇംഗ്ലീഷ് ഗദ്യകാരൻ",
    description: "അയ്യപ്പപ്പണിക്കരുടെ ഇംഗ്ലീഷ് ഗദ്യരചനകളും സാഹിത്യ പ്രവർത്തനങ്ങളും പരിചയപ്പെടുക.",
  },
  "/aniyara-shilpi": {
    title: "അയ്യപ്പപ്പണിക്കർ: അണിയറ ശിൽപി",
    description: "അയ്യപ്പപ്പണിക്കരുടെ സാഹിത്യ-സാംസ്കാരിക പ്രവർത്തനങ്ങളിലെ അണിയറ സംഭാവനകൾ.",
  },
  "/ayyappapanikare-kurichulla-grandhangal": {
    title: "അയ്യപ്പപ്പണിക്കരെ കുറിച്ചുള്ള ഗ്രന്ഥങ്ങൾ",
    description: "അയ്യപ്പപ്പണിക്കരെക്കുറിച്ച് പ്രസിദ്ധീകരിച്ച ഗ്രന്ഥങ്ങളും പഠനങ്ങളും പരിചയപ്പെടുക.",
  },
};

const SEO = ({ title, description, image = DEFAULT_IMAGE, type = "website" }) => {
  const { pathname } = useLocation();
  const metadata = pageMetadata[pathname] || pageMetadata["/"];
  const pageTitle = title || metadata.title;
  const pageDescription = description || metadata.description;
  const canonicalUrl = `${SITE_URL}${pathname === "/" ? "/" : pathname}`;
  const structuredData = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: SITE_NAME,
      url: SITE_URL,
      description: pageDescription,
      inLanguage: ["en", "ml"],
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: SITE_NAME,
      url: SITE_URL,
      logo: DEFAULT_IMAGE,
      sameAs: [
        "https://www.youtube.com/@ayyappapanikerfoundation5666",
        "https://www.instagram.com/ayyappapaniker_foundation",
        "https://www.facebook.com/ayyappapanikerofficial",
      ],
    },
    {
      "@context": "https://schema.org",
      "@type": "Person",
      name: "Ayyappa Paniker",
      url: SITE_URL,
      description: "Ayyappa Paniker was a Malayalam poet, literary critic, translator, and scholar.",
      image: DEFAULT_IMAGE,
      sameAs: [SITE_URL],
    },
  ];

  return (
    <Helmet>
      <html lang={malayalamRoutes.has(pathname) ? "ml" : "en"} />
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta name="author" content="Ayyappa Paniker Foundation" />
      <meta name="robots" content="index, follow, max-image-preview:large" />
      <link rel="canonical" href={canonicalUrl} />
      <link rel="alternate" hrefLang="en" href={canonicalUrl} />
      <link rel="alternate" hrefLang="ml" href={canonicalUrl} />
      <link rel="alternate" hrefLang="x-default" href={canonicalUrl} />

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content="Ayyappa Paniker Foundation" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:locale:alternate" content="ml_IN" />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content="Ayyappa Paniker Foundation" />

      {structuredData.map((data, index) => (
        <script type="application/ld+json" key={index}>
          {JSON.stringify(data)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
